<template>
  <transition name="fade">
    <div
      v-show="visible"
      class="busy-global"
    >
      <c-busy
        :size="1.5"
        class="busy-global__busy"
      />
      <p class="busy-global__text">Wird geladen…</p>
    </div>
  </transition>
</template>

<script>
import CBusy from '@/components/CBusy'

import scrolling from '@/functions/scrolling'

export default {
  name: 'SBusyGlobal',

  components: {
    CBusy
  },

  computed: {
    visible () {
      return this.$store.state.loading === this.$config.status.LOADING
    }
  },

  watch: {
    visible () {
      this.handleVisibilityChange()
    }
  },

  mounted () {
    this.handleVisibilityChange()
  },

  methods: {
    handleVisibilityChange () {
      if (this.visible) {
        scrolling.disable()
      } else {
        scrolling.enable()
      }
    }
  }
}
</script>

<style scoped>
.busy-global {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: var(--z-index-busy-global);

  background-color: rgba(255, 255, 255, 0.9);
}

.busy-global__busy {
  color: var(--color-brand);
}

.busy-global__text {
  margin: 1em;
  text-align: center;
}
</style>
